import { createStore, Store as VuexStore } from 'vuex'

export const InitializationState = {
  NotInitialized: 'NotInitialized',
  Initializing: 'Initializing',
  Initialized: 'Initialized',
}

export type Profile = 'developer' | 'user'
export type State = {
  organisationId: string | null
  initializationState: string
  profile: Profile
}

export type Store = VuexStore<State>
export default createStore<State>({
  state: {
    organisationId: null,
    initializationState: InitializationState.NotInitialized,
    profile: 'user',
  },
  mutations: {
    setInitializationState: (state, newState: string) => {
      state.initializationState = newState
    },
    setOrganisationId: (state, organisationId: string) => {
      state.organisationId = organisationId
    },
    setProfile: (state, profile: Profile) => {
      state.profile = profile
    },
  },
  actions: {},
  modules: {},
})
